
const digest = '3ac86f04e7412101b02f4930c549ac7570fe49aa58b2efc5a5b90ef772c7f198';
const classes = {"wrapper":"_wrapper_fmyzj_1"};
const css = `._wrapper_fmyzj_1 {
  display: flex;
  position: absolute;
  right: 0;
  padding: 8px;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  